const translation = {
    confirm: 'Es-tu sûr?',
    common: { back: 'Dos' },
    save: 'Sauvegarder',
    returnToGame: 'Êtes-vous sûr de vouloir revenir dans le jeu ?',
    yes: 'Oui',
    no: 'Non',
    login: {
        auth: 'Autorisation',
        noAcc: 'Pas de compte',
        reg: 'Registre',
        mail: 'Connectez-vous par e-mail',
        registration: 'Inscription',
        agreement: 'En cliquant sur le bouton « S\'inscrire », vous confirmez votre',
        agreementLink: 'consentement au traitement des données personnelles.',
        submit: 'Registre',
        continue: 'Continuer',
        emailLabel: 'E-mail',
        passwordLabel: 'Mot de passe',
        repeatPasswordLabel: 'Répéter le mot de passe',
        loginButton: 'Se connecter',
        logout: 'Se déconnecter',
        invalidEmail: 'Format d’email invalide',
        invalidFormatPassword: 'Format de mot de passe incorrect',
        forgotPassword: 'Mot de passe oublié',
        passwordRecovery: 'Récupération de mot de passe',
        passwordRecoveryTitle: 'Nous enverrons une lettre à l’e-mail spécifié',
        sendLetter: 'Envoyer une lettre',
        userExists: 'L’utilisateur avec cet e-mail existe',
        userNotExists: 'L’utilisateur avec cet e-mail n’existe pas',
        passwordResetToMail: 'Les instructions pour réinitialiser votre mot de passe ont été envoyées par e-mail',
        passwordValidation: 'Doit contenir de 8 à 20 lettres ou chiffres latins',
        invalidPassword: 'Mot de passe incorrect',
        sessionNotFound: 'Séance introuvable',
        mismatchPassword: 'Non concordance des mots de passe! Essayer à nouveau',
        rememberPassword: 'Mémorisé votre mot de passe',
        restore: 'Restaurer',
        accExist: 'Avoir un compte',
        confirmationCode: 'Saisissez le code de confirmation envoyé par email',
        code: 'Code de confirmation',
        send: 'Envoyer',
        confirmation: 'Confirmer',
        resend: 'Renvoyer',
        codeIsValid: 'Le code est valide',
        codeNotValid: 'Le code n’est pas valide',
        newPassword: 'Entrer un nouveau mot de passe',
        passwordUsedBefore: 'Le mot de passe a déjà été utilisé auparavant',
        passwordUpdatedSuccessfully: 'Mot de passe mis à jour avec succès',
        enterEmail: 'Entrez votre adresse email',
        enterPassword: 'Entrer le mot de passe',
        enterPasswordAgain: 'Entrez à nouveau votre mot de passe',
        enterAgreement: 'Confirmez votre consentement au traitement des données personnelles',
        notRobot: 'Prouvez que vous n\'êtes pas un robot',
        deletionPersonalData: 'Pour supprimer des données personnelles, envoyez-nous un message par e-mail.',
    },
    profile: {
        edit: 'Editer le profil',
        remove: 'Supprimer le compte',
        projectName: 'Nom du projet',
        editing: 'Modification de votre profil',
        name: 'Votre nom',
        lastName: 'Votre nom de famille',
        inputPattern: 'De deux à dix lettres',
        purchases: 'Les achats sont absents',
        settings: 'Paramètres',
        transactions: 'Transactions',
    },
    payment: {
        toPay: 'payer',
        method: 'Mode de paiement',
        pay: 'Payer',
        purchases: 'Achats',
        paymentMethod: 'Mode de paiement',
        debitCard: 'Carte de débit',
        copy: 'ID de paiement copié!',
        cancellation: 'Êtes-vous sûr de vouloir annuler le paiement?',
        email: 'Courriel pour recevoir un reçu',
        status: {
            none: 'Aucun',
            pending: 'En attente',
            paid: 'Payé',
            fail: 'Échec',
        },
        state: {
            progress: 'Le paiement est en cours',
            wait: 'Veuillez patienter',
            paid: 'Payé',
            successful: 'Paiement réussi',
            notPaid: 'Non payé',
            error: 'Erreur',
            cancelled: 'Paiement annulé',
            cancel: 'Annuler',
        },
    },
    games: {
        header: {
            buttonGuest: 'Invité',
            buttonLogin: 'Connexion',
            buttonLogout: 'Déconnexion',
        },
        buttonPlay: 'Jouer',
        buttonInDevelop: 'En développement',
    },
    support: {
        noPurchases: "Vous n'avez pas encore d'achats",
        contactSupport: 'Contacter le support',
        paymentId: 'ID de paiement',
        userId: 'ID utilisateur',
        requestReason: 'Raison de la demande',
        feedbackEmail: 'Email pour retour',
        dropNotCredited: 'Drop non crédité',
        other: 'Autre',
        success: 'Demande acceptée',
        successText: 'Nous avons reçu votre demande et vous contacterons par e-mail prochainement',
    },
    receipt: {
        generation: 'Génération du reçu',
        wait: 'Cela peut prendre un certain temps, veuillez patienter.'
    },
}

export default {
    translation,
}
